module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box",
    attrs: {
      "id": "echartsView"
    }
  }), _vm._v(" "), (false) ? _c('div', {
    staticClass: "box1"
  }, [_c('timechangpage')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70533e1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chart.vue
// module id = 1101
// module chunks = 1